export const BEGIN_API_CALL = 'BEGIN_API_CALL';
export const API_CALL_ERROR = 'API_CALL_ERROR';
export const API_CALL_STATE_RESET = 'API_CALL_STATE_RESET';

export const LOAD_DOT_MAILER_TRACKER_ENTRIES_SUCCESS = 'LOAD_DOT_MAILER_TRACKER_ENTRIES_SUCCESS';
export const LOAD_DOT_MAILER_TRACKER_ENTRIES_ERROR = 'LOAD_DOT_MAILER_TRACKER_ENTRIES_ERROR';
